import { render, staticRenderFns } from "./LabourReportTable.vue?vue&type=template&id=2f40ad44&scoped=true"
import script from "./LabourReportTable.vue?vue&type=script&lang=js"
export * from "./LabourReportTable.vue?vue&type=script&lang=js"
import style0 from "./LabourReportTable.vue?vue&type=style&index=0&id=2f40ad44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f40ad44",
  null
  
)

export default component.exports